import { useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useIntl } from "react-intl";

//Components
import { Grid, Typography, Container, Paper, Divider, Icon } from "@mui/material";
import DataView from 'Components/DataView';

//Views
import AlertTypeDetails from 'Modules/alertTypes/views/main/.components/alertTypeDetails';

//Helpers
import { getDateFormatted, idsValidation } from 'Core/data/Helpers';

//Actions
import {
    alertTypesDetailsOpenModal,
} from 'Redux/actions';

const AlertTypesMain = (props) => {
    const { messages } = useIntl();
    const tableRef = useRef(null);
    const dispatch = useDispatch();

    //Redux States
    const openModal = useSelector(state => state.alertTypeDetailsRedux.openModal);

    //Local States
    const [total, setTotal] = useState(0);
    const [columns, setColumns] = useState([
        {
            key: 'view',
            show: true,
            locked: true,
            title: "",
            width: 50,
            icon: true,
            render: (item) => {
                return (
                    <Icon style={{ cursor: "pointer" }} className="toolbar-list-icon fs-20" onClick={() => {
                        dispatch(alertTypesDetailsOpenModal(true, item))
                    }}>
                        remove_red_eye
                    </Icon>
                )
            }
        },
        {
            key: "id",
            field: "id",
            title: messages['alert_types_id'],
            width: 50,
            show: true,
            sort: true,
            locked: true,
            resize: true,
            export: true,
            code: "alert_types_id",
            functionString: 'return row?.id',
            render: (item) => {
                return <span>{item?.id}</span>
            }
        },
        {
            key: "parentId",
            field: "parentId",
            title: messages['alert_types_parent_id'],
            width: 150,
            show: true,
            sort: false,
            locked: true,
            resize: true,
            export: true,
            code: "alert_types_parent_id",
            functionString: 'return row?.parentId',
            render: (item) => {
                return <span>{item?.parentId}</span>
            }
        },
        {
            key: "name",
            field: "name",
            title: messages['alert_types_name'],
            show: true,
            sort: true,
            locked: false,
            resize: true,
            export: true,
            code: "alert_types_name",
            functionString: 'return row?.name',
            render: (item) => {
                return <span>{item?.name}</span>
            }
        },
        {
            key: "code",
            field: "code",
            title: messages['alert_types_code'],
            show: true,
            sort: true,
            locked: false,
            resize: true,
            export: true,
            code: "alert_types_code",
            functionString: 'return row?.code',
            render: (item) => {
                return <span>{item?.code}</span>
            }
        },
        {
            key: "createdOn",
            field: "createdOn",
            title: messages['alert_types_created_on'],
            sort: true,
            show: true,
            locked: false,
            resize: true,
            export: true,
            code: "alert_types_created_on",
            render: (item) => {
                return <span>{item?.createdOn && getDateFormatted(item?.createdOn, "date", "datetime", null, item?.timezone)}</span>
            }
        },
    ]);
    const [searchFields, setSearchFields] = useState(["name", "code"]);

    return (
        <Container maxWidth={false} className="container-view">
            <Paper elevation={0}>
                <Grid
                    container
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="center"
                    style={{ padding: "14px 18px", borderBottom: "1px solid #e8e8e8", height: '95v' }}
                >
                    <Grid item xs={6}>
                        <Typography variant="h5" gutterBottom component="div">
                            {messages['alert_types_title']} ({total})
                        </Typography>
                    </Grid>
                    <Grid item xs={6} className="main-view-buttons" style={{ display: 'flex', alignItems: 'center' }}>

                    </Grid>

                    <div style={{ width: '100%', marginBottom: 10, marginTop: 5 }}>
                        <Divider style={{ backgroundColor: '#999999' }} />
                    </div>
                    <DataView
                        key="pm_main_alert_types"
                        ref={tableRef}
                        exportName="alerttypes"
                        dinamicQuery
                        noAutomaticSearch
                        name="pm-alert-types-main"
                        entity="alert-types"
                        graphqlFunction="searchAlertTypes"
                        graphqlSort="AlertTypeSortInput"
                        graphqlConditions="AlertTypeSearchInput"
                        customQuery="id"
                        columns={columns}
                        hideAllInPagination
                        onChangeConditions={(tags, conditions, total, newColumns, rows, sort) => {
                            let currentConditions = {}
                            let currentTags = {}
                            if (!conditions && tags) {
                                currentConditions = tableRef?.current?.conditions;
                                currentTags = tags
                            } else {
                                currentConditions = conditions || [];
                                currentTags = currentConditions?.filter((x) => x?.tags)[0]?.tags || [];
                                if (currentTags && currentTags.length > 0) tableRef?.current?.setTags(currentTags);
                            }

                            currentConditions = currentConditions?.filter((item) => item?.fields[0] !== 'id' && item?.fields[0] !== 'name');
                            
                            let tagsById = currentTags.filter((item) => typeof item.id === "number");
                            if (tagsById?.length > 0) {
                                //New Items
                                let currentIds = tagsById.map((item) => (item.id));
                                if (currentIds.length > 0) {
                                    currentConditions.push({ fields: ["id"], terms: currentIds, exact: true, tags: currentTags, conditionOperator: "OR" });
                                }
                            }
                            let tagsByLabel = currentTags.filter((item) => typeof item.id === "string");
                            if (tagsByLabel.length > 0) {
                                let currentLabels = tagsByLabel.map((item) => (item.name))
                                if (currentLabels.length > 0) {
                                    currentConditions.push({ fields: searchFields, terms: currentLabels, exact: false, tags: currentTags, conditionOperator: "OR" })
                                }
                            }

                            if (!currentConditions && tags) tableRef?.current?.getData(null, null, null, currentConditions);
                            else { if (!total) tableRef?.current?.getData(null, rows, sort, currentConditions, newColumns); }
                        }}
                        topheight={200}
                        onChangeTotal={(total) => setTotal(total)}
                        onChangeColumns={(items) => setColumns(items)}
                        tableButtons={['orderColumn', 'export']}
                        onSelectedItems={(items) => { }}
                        //search
                        asyncSelect
                        searchConditions={searchFields}
                        searchFields={searchFields}
                        searchOptionValue="id"
                        searchOptionLabel="name"
                        noFilters
                        noSplit
                    />
                </Grid>
            </Paper>
            {openModal && <AlertTypeDetails />}
        </Container>
    )
}
export default AlertTypesMain;